import React from 'react'
import { Tooltip } from 'antd' ;
import { Button } from 'antd';

import help_icon from './images/help_icon.png'
import nasa_logo from './images/nasa-logo-96.png'
import spdf_icon from './images/spdf_icon_new.png'
import menu_icon from './images/menu_icon.png'
import export_icon from './images/export_icon.png'
import screenshot_icon from './images/screenshot_icon.png'
import options_icon from './images/options_icon.png'
import coord_icon from './images/coordinate_icon.png'
import bookmark_icon from './images/bookmark_icon.png'


import { TOP_BUTTON_STYLE } from './constants.js'
import { SPDF_BUTTON_STYLE } from './constants.js'
import { TT_BGCOLOR } from './constants.js'
import { TITLE } from './constants.js'

class Icon_Bar extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        }

    render ()
        {    
        const filter = {filter: "invert(" + this.props.invert.toFixed() + "%)"}

        //const TT_BGCOLOR = "darkblue" ;
        //const filter={filter: "invert(" + this.props.invert.toFixed() + "%)"}

        const help_button =
        <Tooltip    placement="bottom" 
            color={TT_BGCOLOR}
            title={`Open a dialog box giving basic instructions about how to 
                    use this application`}
            >
            <Button
                size="small"
                type="ghost"
                style={TOP_BUTTON_STYLE}
                onClick={this.props.display_main_help_dialog} 
                >
                <img src={help_icon} className= "icon_image_med" alt="" />
            </Button> 
        </Tooltip> ;

        const menu_button = 
        <Tooltip    placement="bottom" 
            color={TT_BGCOLOR}
            title={`Open a panel allowing the user to select both the observatories 
                    whose orbits will be displayed as well as the time range to view
                    them in.`}
            >
            <Button 
                type="ghost"
                size="small"
                onClick={this.props.toggle_l_sidebar} 
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={menu_icon} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const bookmark_button =
        <Tooltip    placement="bottom" 
            color={TT_BGCOLOR}
            title={`Create a URL that will call the 4D Orbit Viewer application with
                    the currently selected spacecraft and using the current time range.`}
            >
            <Button 
                type="ghost" 
                size="small"
                onClick={this.props.copy_search_url} 
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={bookmark_icon} className= "icon_image" alt="" />
            </Button>
        </Tooltip> ;


        const download_button =
        <Tooltip    placement="bottom" 
            color={TT_BGCOLOR}
            title={`Open a dialog box allowing the user to select spacecraft to have
                    their orbit data exported as a text file. The orbit data of the 
                    selected spacecraft will appear in a new window.  The browser 
                    can then be used to save or print the data file.`}
            >
            <Button 
                type="ghost" 
                size="small"
                onClick={this.props.open_save_menu} 
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={export_icon} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const screenshot_button = 
        <Tooltip    placement="bottom" 
            color={TT_BGCOLOR}
            title={`Save the screen as PNG image.`}
            >

            <Button 
                type="ghost" 
                size="small"
                onClick={this.props.open_image_save_menu} 
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={screenshot_icon} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const options_button = 
        <Tooltip    placement="bottom"
            color={TT_BGCOLOR}
            title={`Open a dialog box allowing the user to select various options.`}
            >                    
            <Button 
                type="ghost" 
                size="small"
                onClick={this.props.open_option_menu} 
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={options_icon} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const coord_button = 
        <Tooltip    placement="bottom"
            color={TT_BGCOLOR}
            title={`Select the coordinate system.`}
            >                    
            <Button 
                type="ghost" 
                size="small"
                onClick={this.props.open_coord_dialog}
                style={TOP_BUTTON_STYLE}
                >
                <img style={filter} src={coord_icon} className= "icon_image" alt="" />
            </Button>
        </Tooltip> ;

        const nasa_button = 
            <Button
            size="small"
            type="ghost"
            onClick={() => window.open('https://www.nasa.gov/', '_blank')} 
            style={TOP_BUTTON_STYLE}
            >
            <img src={nasa_logo} className= "icon_image_large" alt="" />
        </Button>
        const spdf_button = 
        <Button
            size="small"
            type="ghost"
            onClick={() => window.open('https://spdf.gsfc.nasa.gov/', '_blank')} 
            style={SPDF_BUTTON_STYLE}
            >
            <img style={filter} src={spdf_icon} className= "icon_image_spdf" alt="" />
        </Button>
        const id_string = <div id="title">{TITLE}</div>

        
        return (
            <div className="icon_bar"> 
                <div className="icon_left">
                    {menu_button}
                    {download_button}
                    {screenshot_button}
                    {options_button}
                    {coord_button}
                    {bookmark_button}
                    {help_button}
                </div>

                <div className="icon_right">
                    {id_string}
                    {nasa_button}
                    {spdf_button}
                </div>
            </div>
            ) ;
        }
    }

export default Icon_Bar